/* tslint:disable */
/* eslint-disable */
/**
 * Thynk Direct API
 * The API for managing reservation for [Thynk Direct](https://thynk.cloud/).
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// May contain unused imports in some cases
// @ts-ignore
import { BookingEventTypeReservationRead } from './booking-event-type-reservation-read';
// May contain unused imports in some cases
// @ts-ignore
import { CompanyReservationRead } from './company-reservation-read';
// May contain unused imports in some cases
// @ts-ignore
import { ContactReservationRead } from './contact-reservation-read';
// May contain unused imports in some cases
// @ts-ignore
import { ContractReservationRead } from './contract-reservation-read';
// May contain unused imports in some cases
// @ts-ignore
import { LocationReservationRead } from './location-reservation-read';
// May contain unused imports in some cases
// @ts-ignore
import { MailAttachmentReservationRead } from './mail-attachment-reservation-read';
// May contain unused imports in some cases
// @ts-ignore
import { MeetingReservationRead } from './meeting-reservation-read';
// May contain unused imports in some cases
// @ts-ignore
import { ReservationApiLogReservationRead } from './reservation-api-log-reservation-read';
// May contain unused imports in some cases
// @ts-ignore
import { ReservationDayReservationRead } from './reservation-day-reservation-read';
// May contain unused imports in some cases
// @ts-ignore
import { ReservationFileReservationRead } from './reservation-file-reservation-read';
// May contain unused imports in some cases
// @ts-ignore
import { ReservationMailReservationRead } from './reservation-mail-reservation-read';
// May contain unused imports in some cases
// @ts-ignore
import { ReservationRemarkReservationRead } from './reservation-remark-reservation-read';
// May contain unused imports in some cases
// @ts-ignore
import { ReservationRoomReservationRead } from './reservation-room-reservation-read';
// May contain unused imports in some cases
// @ts-ignore
import { UserReservationRead } from './user-reservation-read';

/**
 * A hotelroom and/or MICE reservation made (part of case).
 * @export
 * @interface ReservationRead
 */
export interface ReservationRead {
  /**
   *
   * @type {string}
   * @memberof ReservationRead
   */
  '@context'?: string | null;
  /**
   *
   * @type {string}
   * @memberof ReservationRead
   */
  '@id'?: string;
  /**
   *
   * @type {string}
   * @memberof ReservationRead
   */
  '@type'?: string;
  /**
   * the database identifier of reservation
   * @type {number}
   * @memberof ReservationRead
   */
  id?: number;
  /**
   * firstname of the contactperson
   * @type {string}
   * @memberof ReservationRead
   */
  contactpersonFirstname?: string | null;
  /**
   * lastname of the contactperson
   * @type {string}
   * @memberof ReservationRead
   */
  contactpersonLastname?: string | null;
  /**
   * company of the contactperson
   * @type {string}
   * @memberof ReservationRead
   */
  company?: string | null;
  /**
   * chamber of commerce number of the company
   * @type {string}
   * @memberof ReservationRead
   */
  coc?: string | null;
  /**
   * streetname of the company
   * @type {string}
   * @memberof ReservationRead
   */
  street?: string | null;
  /**
   * housenumber of the company
   * @type {string}
   * @memberof ReservationRead
   */
  housenumber?: string | null;
  /**
   * zipcode of the company
   * @type {string}
   * @memberof ReservationRead
   */
  postalcode?: string | null;
  /**
   * city of the company
   * @type {string}
   * @memberof ReservationRead
   */
  city?: string | null;
  /**
   * country of the company in a 2 letter ISO 3166 format (default NL)
   * @type {string}
   * @memberof ReservationRead
   */
  country?: string | null;
  /**
   * phonenumber of the contactperson
   * @type {string}
   * @memberof ReservationRead
   */
  phonenumber?: string | null;
  /**
   * phonenumber of the company
   * @type {string}
   * @memberof ReservationRead
   */
  companyPhonenumber?: string | null;
  /**
   * indicates of the contactperson would like to receive newsletters
   * @type {boolean}
   * @memberof ReservationRead
   */
  newsletter?: boolean;
  /**
   * used for persisting the unprocessed address retrieved by the processor
   * @type {string}
   * @memberof ReservationRead
   */
  unprocessedAddress?: string | null;
  /**
   * the name of the event
   * @type {string}
   * @memberof ReservationRead
   */
  eventname?: string | null;
  /**
   * the name of the event that should be displayed at the hall entry
   * @type {string}
   * @memberof ReservationRead
   */
  hallEntry?: string | null;
  /**
   * name of the contactperson on location
   * @type {string}
   * @memberof ReservationRead
   */
  contactpersonLocation?: string | null;
  /**
   * a reference for the invoice provided by the customer
   * @type {string}
   * @memberof ReservationRead
   */
  invoiceReference?: string | null;
  /**
   * an additional comment about the invoice reference
   * @type {string}
   * @memberof ReservationRead
   */
  invoiceReferenceComment?: string | null;
  /**
   * percentage of commission
   * @type {number}
   * @memberof ReservationRead
   */
  commission?: number;
  /**
   * the discount in percentage given on the total invoice
   * @type {string}
   * @memberof ReservationRead
   */
  invoiceDiscount?: string;
  /**
   * the method the customer should use for the payment
   * @type {string}
   * @memberof ReservationRead
   */
  paymentMethod?: string | null;
  /**
   * current marking/state of the reservation in the workflow
   * @type {string}
   * @memberof ReservationRead
   */
  marking?: ReservationReadMarkingEnum;
  /**
   * the locale/language for this reservation (ISO 3166). if available, the mails to customer will be sent in this language
   * @type {string}
   * @memberof ReservationRead
   */
  locale?: string;
  /**
   * use the overbook option in the external system
   * @type {boolean}
   * @memberof ReservationRead
   */
  overbookMeeting?: boolean;
  /**
   * the date when an option will expire
   * @type {string}
   * @memberof ReservationRead
   */
  expirationDate?: string | null;
  /**
   * the generated reservation number in the platform (used in the correspondance with the customer)
   * @type {string}
   * @memberof ReservationRead
   */
  reservationNumber?: string | null;
  /**
   * the text representation of cancellation reason
   * @type {string}
   * @memberof ReservationRead
   */
  cancelReasonText?: string | null;
  /**
   * determines if the reservation was changed manually by an employee
   * @type {boolean}
   * @memberof ReservationRead
   */
  manuallyChanged?: boolean;
  /**
   * the reference of the agency
   * @type {string}
   * @memberof ReservationRead
   */
  agencyReference?: string | null;
  /**
   *
   * @type {Array<string>}
   * @memberof ReservationRead
   */
  flags?: Array<string>;
  /**
   *
   * @type {Array<ReservationDayReservationRead>}
   * @memberof ReservationRead
   */
  days?: Array<ReservationDayReservationRead>;
  /**
   *
   * @type {Array<ReservationRoomReservationRead>}
   * @memberof ReservationRead
   */
  rooms?: Array<ReservationRoomReservationRead>;
  /**
   *
   * @type {Array<ReservationFileReservationRead>}
   * @memberof ReservationRead
   */
  files?: Array<ReservationFileReservationRead>;
  /**
   *
   * @type {Array<ReservationRemarkReservationRead>}
   * @memberof ReservationRead
   */
  remarks?: Array<ReservationRemarkReservationRead>;
  /**
   *
   * @type {Array<ReservationApiLogReservationRead>}
   * @memberof ReservationRead
   */
  apiLogs?: Array<ReservationApiLogReservationRead>;
  /**
   *
   * @type {Array<ReservationMailReservationRead>}
   * @memberof ReservationRead
   */
  mails?: Array<ReservationMailReservationRead>;
  /**
   * a fee should be added if the customer cancels the reservation
   * @type {boolean}
   * @memberof ReservationRead
   */
  cancellationFee?: boolean | null;
  /**
   *
   * @type {LocationReservationRead}
   * @memberof ReservationRead
   */
  location?: LocationReservationRead | null;
  /**
   *
   * @type {MeetingReservationRead}
   * @memberof ReservationRead
   */
  meeting?: MeetingReservationRead | null;
  /**
   *
   * @type {ContractReservationRead}
   * @memberof ReservationRead
   */
  contract?: ContractReservationRead | null;
  /**
   *
   * @type {UserReservationRead}
   * @memberof ReservationRead
   */
  user?: UserReservationRead | null;
  /**
   * related case
   * @type {string}
   * @memberof ReservationRead
   */
  dossier?: string | null;
  /**
   *
   * @type {Array<MailAttachmentReservationRead>}
   * @memberof ReservationRead
   */
  mailAttachments?: Array<MailAttachmentReservationRead>;
  /**
   *
   * @type {Array<string>}
   * @memberof ReservationRead
   */
  enabledTransitions?: Array<string>;
  /**
   * The executor is an intermediate party, like a travel agent.
   * @type {ContactReservationRead}
   * @memberof ReservationRead
   */
  executorContact?: ContactReservationRead;
  /**
   *
   * @type {CompanyReservationRead}
   * @memberof ReservationRead
   */
  executorCompany?: CompanyReservationRead;
  /**
   * related contact on site
   * @type {ContactReservationRead}
   * @memberof ReservationRead
   */
  onsiteContact?: ContactReservationRead;
  /**
   * related partner
   * @type {string}
   * @memberof ReservationRead
   */
  partner?: string | null;
  /**
   *
   * @type {Array<string>}
   * @memberof ReservationRead
   */
  types?: Array<ReservationReadTypesEnum>;
  /**
   * shows the source of the reservation (phone, manually, mail etc.)
   * @type {string}
   * @memberof ReservationRead
   */
  source?: ReservationReadSourceEnum;
  /**
   * the url to the terms and condition at the time of the reservation
   * @type {string}
   * @memberof ReservationRead
   */
  termsUrl?: string | null;
  /**
   *
   * @type {BookingEventTypeReservationRead}
   * @memberof ReservationRead
   */
  bookingEventType?: BookingEventTypeReservationRead | null;
  /**
   *
   * @type {number}
   * @memberof ReservationRead
   */
  totalPrice?: number;
}

export const ReservationReadMarkingEnum = {
  Start: 'start',
  AwaitingMailingLink: 'awaiting_mailing_link',
  LinkMailed: 'link_mailed',
  ProposalRequested: 'proposal_requested',
  AvailabilityChecking: 'availability_checking',
  AvailabilitySucceeded: 'availability_succeeded',
  AvailabilityFailed: 'availability_failed',
  HotelroomoptionChecking: 'hotelroomoption_checking',
  HotelroomoptionSucceeded: 'hotelroomoption_succeeded',
  HotelroomoptionFailed: 'hotelroomoption_failed',
  MeetingroomoptionChecking: 'meetingroomoption_checking',
  MeetingroomoptionSucceeded: 'meetingroomoption_succeeded',
  AwaitingMailingMeetingroomoptionChanges:
    'awaiting_mailing_meetingroomoption_changes',
  MeetingroomoptionChangesMailed: 'meetingroomoption_changes_mailed',
  MeetingroomoptionFailed: 'meetingroomoption_failed',
  AwaitingMailingProposal: 'awaiting_mailing_proposal',
  ProposalMailed: 'proposal_mailed',
  ProposalMailedManually: 'proposal_mailed_manually',
  ProposalAccepted: 'proposal_accepted',
  HotelroombookingConfirming: 'hotelroombooking_confirming',
  HotelroombookingSucceeded: 'hotelroombooking_succeeded',
  HotelroombookingFailed: 'hotelroombooking_failed',
  MeetingroombookingConfirming: 'meetingroombooking_confirming',
  MeetingroombookingSucceeded: 'meetingroombooking_succeeded',
  MeetingroombookingFailed: 'meetingroombooking_failed',
  AwaitingMailingConfirmation: 'awaiting_mailing_confirmation',
  ConfirmationMailed: 'confirmation_mailed',
  ConfirmationMailedManually: 'confirmation_mailed_manually',
  Cancelled: 'cancelled',
  Expired: 'expired',
  ProcessedManually: 'processed_manually',
  NoAction: 'no_action',
} as const;

export type ReservationReadMarkingEnum =
  (typeof ReservationReadMarkingEnum)[keyof typeof ReservationReadMarkingEnum];
export const ReservationReadTypesEnum = {
  Mice: 'mice',
  Hotel: 'hotel',
} as const;

export type ReservationReadTypesEnum =
  (typeof ReservationReadTypesEnum)[keyof typeof ReservationReadTypesEnum];
export const ReservationReadSourceEnum = {
  Broker: 'broker',
  Mail: 'mail',
  Form: 'form',
  Booking: 'booking',
  Employee: 'employee',
  Phone: 'phone',
} as const;

export type ReservationReadSourceEnum =
  (typeof ReservationReadSourceEnum)[keyof typeof ReservationReadSourceEnum];
